
export enum ESearchEventName {

  onSuffixClick = 'onSuffixClick',

  onTabChange = 'onTabChange',

  onHotSearchClick = 'onHotSearchClick',

  onDatalistClick = 'onDatalistClick',

  onAutoCompleteClick = 'onAutoCompleteClick',

  onDataListRemove = 'onDataListRemove'
}



// WEBPACK FOOTER //
// ./src/components/OYSearch/enum.ts